import React from "react";
import {FontAwesomeIcon, FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {faDotCircle} from "@fortawesome/free-solid-svg-icons/faDotCircle";
import {faFilePdf} from "@fortawesome/free-solid-svg-icons/faFilePdf";
import {faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import {faTruckFast} from "@fortawesome/free-solid-svg-icons/faTruckFast";
import {faCartShopping} from "@fortawesome/free-solid-svg-icons/faCartShopping";
import {faCircleCheck} from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import {faSpinner} from "@fortawesome/free-solid-svg-icons/faSpinner";

const green = "#25a24e"

const IconCheck = () => {
    return (
        <FontAwesomeIcon icon={faCheck} color={green} />
    )
}

const IconSender = () => {
    return (
        <FontAwesomeIcon icon={faDotCircle} color={green} size="2x" />
    )
}

const IconReceiver = (props: {
    style?: FontAwesomeIconProps['style']
}) => {
    return (
        <FontAwesomeIcon style={props.style} icon={faMapMarkerAlt} color="#e93530" size="2x" />
    )
}

const IconFilePDF = () => {
    return (
        <FontAwesomeIcon icon={faFilePdf} color="#cf3a36" />
    )
}

const IconTruckFast = () => {
    return (
        <FontAwesomeIcon icon={faTruckFast} />
    )
}

const IconShoppingCart = () => {
    return (
        <FontAwesomeIcon icon={faCartShopping} />
    )
}

const IconCircleCheck = () => {
    return (
        <FontAwesomeIcon icon={faCircleCheck} />
    )
}

const IconExclamationTriangle = () => {
    return (
        <FontAwesomeIcon icon={faExclamationTriangle} />
    )
}

const IconSpin = (props: {spin: boolean}) => {
    return (
        <FontAwesomeIcon icon={faSpinner} spin={props.spin} />
    )
}

export {
    IconCheck,
    IconSender,
    IconReceiver,
    IconFilePDF,
    IconTruckFast,
    IconShoppingCart,
    IconCircleCheck,
    IconExclamationTriangle,
    IconSpin
}
